<template>
    <div>
        <header-message class="mt-4 mb-4">
            Is the Measured Windshield Angle
            <span class="angle">{{ angleText }} &deg;</span>?
        </header-message>

        <div class="container-fluid">
            <div class="row mt-4">
                <div class="col-9 imgarea">
                    <img src="/img/Inclinometer400x300.png" alt="Inclinometer" >
                </div>
                <div class="col-3 buttonarea">
                    <div class="ms-auto buttondiv" style="width:auto">
                        <button-button type="button" class="btn btn-secondary me-4" @click.prevent="noClicked" :disabled="loading">No</button-button>
                        <button-button type="button" class="btn btn-secondary me-4" @click.prevent="yesClicked" :disabled="loading">Yes</button-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="assistance mt-4">
            For Assistance Call 904 990-1122
        </div>
    </div>
</template>

<style scoped lang="scss">
    .angle {
        background: white;
        color: black;
        padding:10px;
    }
    .imgarea {
        text-align: center;
    }
    .buttonarea {
        position: relative;
    }
    .buttondiv {
        bottom: 0;
        position: absolute;
    }
    .assistance {
        text-align: center;
        color: orangered;
        font-weight: bold;
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";

import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { Global } from "@/support/GlobalData";
import { SignalR } from "@/support/SignalR";
import { DeviceStatusDto } from "@/shared/models/DeviceStatusDto";

export default defineComponent({
    name: "CalibrationMeasuredWindshieldAngle",
    mixins: [PageBase],
    components: {
        HeaderMessage,
    },
    computed: {
        angleText(): string {
            if (Global.CalibrationSession!.WindshieldOverride) return Global.CalibrationSession!.WindshieldOverride.toFixed(1);
            return Global.CameraViewerConfiguration!.CarWindshieldAngle.toFixed(1);
        },
        angle(): number {
            return Number(this.angleText);
        }
    },
    methods: {
        yesClicked(): void {
            this.$router.push("/Calibration/CameraSetup");
        },
        noClicked(): void {
            this.$router.push("/Calibration/NewWindshieldAngle");
        },
        getCurrentStatusForListeners(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationMeasuredWindshieldAngle",
                WindshieldAngle: this.angle,
            } as DeviceStatusDto);
        }
    },
    mounted(): void {
        SignalR.onGetCurrentStatusForListeners = this.getCurrentStatusForListeners;
        SignalR.onMeasuredWindshieldAngleCorrectByCompanion = (correct: boolean): void => {
            if (correct)
                this.yesClicked();
            else
                this.noClicked();
        };
        this.getCurrentStatusForListeners();
    },
    unmounted(): void {
        SignalR.onGetCurrentStatusForListeners = null;
        SignalR.onMeasuredWindshieldAngleCorrectByCompanion = null;
    }
});
</script>
